import React from 'react';
import ActivePortfolioBubble from './ActivePortfolioBubble';
import { useAppSelector } from '../../../store/reducers/store';
import { useTranslation } from 'react-i18next';

const positions = ["120,-50", "-50,-80", "5,50"];
const types = ['primary', 'secondary', 'tertiary'];
const ActivePortfolioBubbles: React.FC = () => {
    const portfolioCompletions = useAppSelector(state => state.dashboard.portfolioCompletions);
    const { t } = useTranslation();

    if (portfolioCompletions === undefined) {
        return <>
            {[0, 1, 2].map(index =>
                <g transform={`translate(${positions[index]})`} key={`portfolio-${index}`}>
                    <ActivePortfolioBubble type={types[index] as any} loading={true} />
                </g>)}
        </>;
    }
    return <>
        {portfolioCompletions.map((completion, index) =>
            <g transform={`translate(${positions[index]})`} key={`portfolio-${completion.name}`}>
                <ActivePortfolioBubble id={completion.id} type={types[index] as any} name={completion.name} completion={completion.raised / completion.target} />
            </g>)}
        {[0, 1, 2].slice(portfolioCompletions.length, 3).map((index) =>
            <g transform={`translate(${positions[index]})`} key={`portfolio-${index}`}>
                <ActivePortfolioBubble type={types[index] as any} name={t('DashboardPortfolioTargetNothing')} />
            </g>)}
    </>;
}

export default ActivePortfolioBubbles;